import { render, staticRenderFns } from "./AdminOfferCard.vue?vue&type=template&id=0e96a590&scoped=true"
import script from "./AdminOfferCard.vue?vue&type=script&lang=js"
export * from "./AdminOfferCard.vue?vue&type=script&lang=js"
import style0 from "./AdminOfferCard.vue?vue&type=style&index=0&id=0e96a590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96a590",
  null
  
)

/* custom blocks */
import block0 from "./AdminOfferCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports